// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"main-form_submitButton__fB82T","formWrapper":"main-form_formWrapper__OW96F","hidden":"main-form_hidden__G7FDW"};